import * as Yup from "yup";

export const importEmployyeValidationSchema = Yup.object().shape({
  // Official Information
  companyCode: Yup.number().required("companyCode is required"),
  employeeCode: Yup.number().min(0).required("employeeCode is required"),
  fullName: Yup.string().required("Employee Name is required"),
  uniqueId: Yup.string().required("Unique Id is required"),
  employeeType: Yup.string().default(""), //.required("Employee Type is required"),
  // 3 is used for Foreigner
  icno: Yup.string().default(""),
  //  when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) => schema.required("Icno is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  finNumber: Yup.string().default(""),
  // .when("employeeType", {
  //   is: (val) => val === "3",
  //   then: (schema) =>
  //     schema
  //       .required("Fin Number is required")
  //       .matches(/^[A-Z]\d{7}[A-Z]$/, "Invalid Fin Number format"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  gender: Yup.string().default(""), //.required("gender is required"),
  race: Yup.string().default(""), //.required("race is required"),
  nationality: Yup.string().default(""), //.required("nationality is required"),

  departmentCode: Yup.string(),
    // .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    // .default(0)
    // .required("Department is required"),

  // .min(1, "Department is required")
  // .typeError("Department is required")
  // .required("Department is required"),
  designationCode: Yup.string(),
    // .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    // .default(0)
    // .required("Designation is required"),
  // .min(1, "Designation is required")
  // .typeError("Designation is required")
  // .required("Designation is required"),
  jobTitle: Yup.string().default(""),
  confirmationDate: Yup.string().default(""),
  joinDate: Yup.string().default(""),
  locationCode: Yup.string().required("Location is required"),
  groups: Yup.string().default(""),
  employmentStatus: Yup.string()
    // .min(0)
    // .typeError("Employment Status is required")
    .required("Employment Status is required"),
  jobGrade: Yup.string().default(""),
  isSupervisor: Yup.boolean().default(false),
  //   .typeError("Select the employee is supervisor or not")
  //   .required("Select the employee is supervisor or not"),
  skilledOrUnSkilled: Yup.string().default(""),
  // .oneOf(["S", "U"])
  // .required("skilledOrUnSkilled is required"),
  workingHoursPerDay: Yup.number()
    .min(0)
    .max(24)
    .required("Working Hours PerDay is required"),
  noofworkingDaysPerWeek: Yup.string() //.default(0),
  // .min(1)
  // .max(7)
  // .typeError("noofworkingDaysPerWeek is required")
  .required("noofworkingDaysPerWeek is required"),
  restDay: Yup.string().default(""),
  // .test("restDay", "Select rest day", (value, context) => {
  //   return (
  //     value?.split(",")?.length >= 7 - context.parent.noofworkingDaysPerWeek
  //   );
  // })
  // .required("Rest day is required"),
  lengthofNoticePeriod: Yup.string().default("0"), //.required("lengthofNoticePeriod is required"),
  //   .required(
  //     "lengthofNoticePeriod is required"
  //   ),
  probationPeriodEnd: Yup.string().default(""),
  probationPeriodStart: Yup.string().default(""),

  //  CPF Details
  residentialType: Yup.string().default(""),
  // when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) => schema.required("CPF contribution type is required"),
  //   otherwise: (schema) => schema.default("OS").notRequired(),
  // }),
  contributionCode: Yup.string().default(""),
  // .when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) =>
  //     schema
  //       .typeError("Contribution Code is required")
  //       .required("Contribution Code is required"),
  //   otherwise: (schema) =>
  //     schema
  //       .default(0)
  //       .transform((value, originalValue) => (originalValue === "" ? 0 : value))
  //       .notRequired(),
  // }),

  prcpfType: Yup.string().default(""),
  // .when("employeeType", {
  //   is: (val) => val !== "3", // || val !== 3, // || (val !== "1" && val !== 1),
  //   then: (schema) => schema.required("PR CPF Type is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  contributesSDL: Yup.string().default(""),
  // .when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) =>
  //     schema
  //       .typeError("Contribute SDL is required")
  //       .required("Contribute SDL is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  sdlBreakdown: Yup.string().default(""), //.required("SDL Breakdown is required"),
  prDate: Yup.string().default(""),
  ppeSize: Yup.string().default(""), //.required("PPE size is required"),
  shoeSize: Yup.string().default(""), //.required("Shoe size is required"),
  ppeRemarks: Yup.string().default(""), //.required("PPE Remarks is required"),
  employeeLogin: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      employeeID: Yup.number(),
      userName: Yup.string().required("User Name is required"),
      password: Yup.string().required("Password is required"),
      userType: Yup.string().required("User type is required"),
      defaultLoginLatitude: Yup.number(),
      defaultLoginLongitude: Yup.number(),
      lastLogin: Yup.string().default(""),
      createUser: Yup.string().default(""),
      createDate: Yup.string().default(""),
      modifyUser: Yup.string().default(""),
      modifyDate: Yup.string().default(""),
      isActive: Yup.boolean().required("Login Active status is required"),
      isLock: Yup.boolean().required("Login Lock status is required"),
      isFirstLogin : Yup.boolean().required("isFirstLogin is required"),
    })
  ),

  //   ID Details
  passCode: Yup.string(), //default(0),
  // .min(1, "please select any one Pass Type")
  // .typeError("please select any one of Pass Type")
  // .required("passCode is required"),

  // Salary Details
  salaryType: Yup.string().default("Hourly"), //required("Salary Type is required"),
  daySalary: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : Number(value)
    )
    .default(0)
    .when("salaryType", {
      is: "Daily",
      then: (schema) =>
        schema
          .required("Day Salary is required for Daily salary type")
          .integer("Day Salary must be an integer")
          .min(1, "Day Salary must be greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),
  hourlySalary: Yup.number()
    .typeError("Hourly Salary must be a valid number")
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : isNaN(originalValue)
        ? NaN
        : Number(originalValue)
    )
    .default(0)
    .when("salaryType", {
      is: "Hourly",
      then: (schema) =>
        schema
          .required("Hourly Salary is required for Hourly salary type")
          .default(0)
          .min(0, "Hourly Salary must be greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),

  basicSalary: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : Number(value)
    )
    .default(0)
    .when("salaryType", {
      is: "Monthly",
      then: (schema) =>
        schema
          .transform((value, originalValue) =>
            originalValue === "" ||
            originalValue === null ||
            originalValue === undefined
              ? 0
              : Number(value)
          )
          .default(0)
          .required("Basic Salary is required for Monthly salary type")
          // .integer("Basic Salary must be an integer")
          .min(0, "Basic Salary must be  greater than 1"),
      otherwise: (schema) => schema.notRequired(),
    }),
  paymentMode: Yup.string(),
    // .min(0, "Payment method is required")
    // .typeError("Payment method is required")
    // .required("Payment method is required"),
  bankName: Yup.string().default(""), //.required("Bank Name is required"),
  accountNo: Yup.string().default(""),
  // .matches(/^\d+$/, "Account No should be numeric")
  // .required("Account No is required"),
  haveOverTimePay: Yup.boolean().required("Have OverTime Pay is required"),
  haveFullPay: Yup.boolean().required("Have full pay is required"),
  otDaySalary: Yup.number().default(0),
  //   .min(0, "otDaySalary is required")
  //   .required("otDaySalary is required"),
  otHourlySalary: Yup.number().default(0),
  //   .min(0, "Ot Hourly Salary is required")
  //   .required("Ot Hourly Salary is required"),

  oT1PayRate: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(0, "OT1 Pay Rate is required")
    .required("OT1 Pay Rate is required"),

  oT2PayRate: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(0, "OT2 Pay Rate is required")
    .required("OT2 Pay Rate is required"),

  oT3PayRate: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(0, "OT3 Pay Rate is required")
    .required("OT3 Pay Rate is required"),

  // Personal Details Section
  dob: Yup.string().required("dob is required"),
  maritalStatus: Yup.string().default(""),
  academicQualification: Yup.string().default(""),
  //   .required(
  //     "academicQualification is required"
  //   ),
  address1: Yup.string().default(""), // required("address1 is required"),
  address2: Yup.string().default(""),
  address3: Yup.string().default(""),
  country: Yup.string().default(""), //.required("country is required"),
  postalCode: Yup.string().default(""),
  // .matches(/^\d{6}$/, "postalCode should be 6 digits")
  // .required("postalCode is required"),
  bloodGroup: Yup.string().default(""), //.required("bloodGroup is required"),
  // .oneOf(["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"])
  // .required("bloodGroup is required"),
  personalEmail: Yup.string().default(""), //.email().required("personalEmail is required"),
  email: Yup.string().default(""), //required("email is required"),
  localContactNumber: Yup.string().default(""), //.required("Local Contact Number is required"),
  // .typeError("Enter Local Contact Number")
  // .required("Enter Local Contact Number"),
  overseasContactNumber: Yup.string().default(""), //.required("Overseas Contact Number is required"),
  // .typeError("Enter Overseas Contact Number")
  // .required("Enter Overseas Contact Number"),
  remarks: Yup.string().default(""),
  passExpiryDate: Yup.string().default(""),
  passIssueDate: Yup.string().default(""),
  cpfEntitled: Yup.string().default(""),
  identification: Yup.string().default(""), //.required("Identification is required"),

  isActive: Yup.bool().required("isActive is required"),
  relationship: Yup.string().default(""), //.required("Relationship is required"),
  emergencyContactPerson: Yup.string().default(""), //.required("Emergency Contact Person is required"),
  // .required(
  //   "emergencyContact Person is required"
  // ),
  hpno: Yup.string().default(""),
  // .matches(/^\d+$/, "Mobile No should be numeric")
  // .required("Mobile No is required"),
  employeePhoto: Yup.string().default(""),
  religion: Yup.string().default(""), //.required("religion is required"),
  placeOfBirth: Yup.string().default(""), //.required("placeOfBirth is required"),

  // .oneOf(["Single", "Married", "Divorced", "Widowed"])
  // .required("maritalStatus is required"),

  otPaidInDays: Yup.number().min(0).required("otPaidInDays is required"),
  officeNo: Yup.string().default(""),
  //   Other Details
  mode: Yup.string().required("mode is required"),
  dateFormat: Yup.string().required("dateFormat is required"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),

  resignedDate: Yup.string().default(""),

  workDayPerWeek: Yup.string()
    // .min(0)
    // .max(7)
    .required("workDayPerWeek is required"),
  reportTo: Yup.string().default(""),
  haveLoginPermission: Yup.boolean().typeError("Select Have Login Permission").required(
    "haveLoginPermission is required"
  ),
  dailyAllowance: Yup.number().min(0).required("dailyAllowance is required"),
  haveOverTimePayForExtraHours: Yup.boolean().required(
    "haveOverTimePayForExtraHours is required"
  ),
  haveNeedAttendance: Yup.boolean().typeError("Select Have Need Attendance").required("have Need Attendance is required"),
  accommodationByCompany: Yup.boolean()
    // .transform((value, originalValue) => {
    //   if (typeof originalValue === "string") {
    //     if (originalValue.toLowerCase() === "Yes") return true;
    //     if (originalValue.toLowerCase() === "No") return false;
    //   }
    //   return originalValue;
    // })
    .default(false),
  // .required("accommodationByCompany is required"),
  loginUserName: Yup.string().default(""),
  aliasName: Yup.string().default(""), // .required("aliasName is required"),
  preferedName: Yup.string().default(""),
  surpervisorName: Yup.string().default(""),
  payrollFrequency: Yup.string().default(""),
  skillSet: Yup.string().default(""),
  basicPayAmountType: Yup.string()
    // .oneOf(["SGD", "USD", "EUR"])
    .required("basicPayAmountType is required"),
  superAdmin: Yup.boolean().required("superAdmin is required"),
  workingTimingPerDay: Yup.string().default(""),
  // .min(0)
  // .max(24)
  // .required("workingTimingPerDay is required"),
  userSecurity: Yup.string().default(""),
  claimsTypes: Yup.string().default(""),
  fundDonation: Yup.string().default(""),
  clockInAndOutOnMobile: Yup.string().default(""),
  // .required("Clock In And Out On Mobile is required"),

  passTypeDetails: Yup.array().of(
    Yup.object().shape({
      // passTypeID: Yup.number()
      //   .transform((value, originalValue) => (originalValue === "" ? 0 : value))
      //   .default(0),
      passCode: Yup.string(),
        // .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        // .default(0),
      nricNumber: Yup.string().default(""),
      // .matches(/^[STFG]\d{7}[A-Z]$/, "Invalid NRIC format") // Singapore NRIC format
      // .required("NRIC Number is required"),
      photoIdBarcode: Yup.string().default(""), //.required("Photo Id Barcode is required"),
      issuedDate: Yup.string().default(""),
      // .typeError("Select the valid date")
      // .required("Issued date is required"),
      sector: Yup.string().default(""), //.required("Sector is required"),
      levyAmount: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .default(0)
        .required("Levy amount is required"),
      frontImage: Yup.string().default(""),
      //   .required(
      //     "please select the document front image"
      //   ),
      backImage: Yup.string().default(""),
      //   .required("please select the document back image"),
    })
  ),
  // inventoryDetails: Yup.array().of(
  //   Yup.object().shape({
  //     companyCode: Yup.number(),
  //     code: Yup.number(),
  //     employeeCode: Yup.number(),
  //     itemName: Yup.string().required("Please enter item name"),
  //     quantity: Yup.number()
  //       .min(1)
  //       .typeError("Please enter item quantity")
  //       .required("Please enter item quantity"),
  //     dateOfIssue: Yup.string().required("Please select issue date"),
  //     dateOfCollection: Yup.string().required("Please select collect date"),
  //     description: Yup.string().default(""),
  //     createUser: Yup.string().default(""),
  //     createDate: Yup.string().default(""),
  //     modifyUser: Yup.string().default(""),
  //     modifyDate: Yup.string().default(""),
  //     isActive: Yup.boolean(),
  //   })
  // ),
  // workExperienceDetails: Yup.array().of(
  //   Yup.object().shape({
  //     companyCode: Yup.number(),
  //     code: Yup.number(),
  //     employeeCode: Yup.number(),
  //     department: Yup.string().required("Please enter department"),
  //     designation: Yup.string().required("Please enter designation"),
  //     weFromdate: Yup.string().required("Please select start date"),
  //     weTodate: Yup.string().required("Please select end date"),
  //     salary: Yup.number().required("Please enter salary"),
  //     remarks: Yup.string().default(""),
  //     createUser: Yup.string().default(""),
  //     createDate: Yup.string().default(""),
  //     modifyUser: Yup.string().default(""),
  //     modifyDate: Yup.string().default(""),
  //     isActive: Yup.boolean(),
  //   })
  // ),
  // certificationsDetails: Yup.array().of(
  //   Yup.object().shape({
  //     courseName: Yup.string().required("course name is required"),
  //     abbreviation: Yup.string().required("abbreviation is required"),
  //     issueDate: Yup.string().required("issue date is required"),
  //     expiryDate: Yup.string().required("expiry date is required"),
  //     documentImage: Yup.string().default(""),
  //     remarks: Yup.string().default(""),
  //   })
  // ),
  // educationalQualificationList: Yup.array().of(
  //   Yup.object().shape({
  //     degreeName: Yup.string().required("degree name is required"),
  //     fieldOfStudy: Yup.string().required("field of study is required"),
  //     institutionName: Yup.string().required("institution name is required"),
  //     startDate: Yup.string().required("start date is required"),
  //     endDate: Yup.string().required("end date is required"),
  //     grade: Yup.string().required("grade is required"),
  //     country: Yup.string().required("country is required"),
  //     documentImage: Yup.string().default(""),
  //     remarks: Yup.string().default(""),
  //   })
  // ),
  // otherVisaDetails: Yup.array().of(
  //   Yup.object().shape({
  //     visaNumber: Yup.string().required("Visa Number is required"),
  //     typeofVisa: Yup.string().required("Type of Visa is required"),
  //     duration: Yup.string().required("Duration is required"),
  //     issuesDate: Yup.string().required("Issues Date is required"),
  //     expiryDate: Yup.string().required("Expiry Date is required"),
  //     issuedBy: Yup.string().required("Issued By is required"),
  //     sposorship: Yup.string().required("Sposorship is required"),
  //     busniessVisa: Yup.string().required("Business Visa is required"),
  //     country: Yup.string().required("Country is required"),
  //     agentName: Yup.string().required("Agent Name is required"),
  //     agentPhone: Yup.number().required("Agent Phone is required"),
  //     agentEmail: Yup.string().required("Agent Email is required"),
  //     frontImage: Yup.string().default(""), //.required("Visa Number is required"),
  //     backImage: Yup.string().default(""), //.required("Visa Number is required"),
  //     isActive: Yup.bool().required("Statis is required"),
  //   })
  // ),
  employmentType: Yup.string().default(""), //.required("Employment Type is required"),
  nsEligible: Yup.boolean(), //.required("NS Eligible is required"),
  contractType: Yup.string().default(""), //.required("Contract Type is required"),
  contractExpiryDate: Yup.string().default(""),
  mondayWorkingMode: Yup.string().default("0"),
  // .required("Monday Working Mode is required"),
  tuesdayWorkingMode: Yup.string().default("0"),
  // .required("Tuesday Working Mode is required"),
  wednesdayWorkingMode: Yup.string().default("0"),
  // .required("Wednesday Working Mode is required"),
  thursdayWorkingMode: Yup.string().default("0"),
  // .required("Thursday Working Mode is required"),
  fridayWorkingMode: Yup.string().default("0"),
  // .required("Friday Working Mode is required"),
  saturdayWorkingMode: Yup.string().default("0"),
  // .required("Saturday Working Mode is required"),
  sundayWorkingMode: Yup.string().default("0"),
  // .required("Sunday Working Mode is required"),
  // alternateWorkingHours: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       isAlternate: Yup.boolean(),
  //       // Add other fields here if needed
  //     })
  //   )
  //   .test(
  //     'validate-if-isAlternate-true',
  //     'At least one valid alternate working hour is required.',
  //     function (value) {
  //       if (!Array.isArray(value)) return true;

  //       const hasAlternate = value.some((item) => item?.isAlternate === true);
  //       if (!hasAlternate) return true; // skip validation if no `isAlternate: true`

  //       // Now ensure there is at least one non-empty object with `isAlternate: true`
  //       return value.some(
  //         (item) =>
  //           item?.isAlternate === true &&
  //           typeof item === 'object' &&
  //           Object.keys(item).length > 0
  //       );
  //     }
  //   ),
  projectCode: Yup.string().default(""),
  extraHoursRate: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(0)
    .required("Extra Hours Rate Required"),
  netcoTrade: Yup.string().default(""),
  momTrade: Yup.string().default(""),
  excludeTime: Yup.string().default(""),
  certificationsDetails: Yup.array().of(
    Yup.object().shape({
      courseName: Yup.string().required("course name is required"),
      abbreviation: Yup.string().required("abbreviation is required"),
      certificateNumber: Yup.string().required(
        "certificate number is required"
      ),
      issueDate: Yup.string().nullable().default(""), //.required("issue date is required"),
      expiryDate: Yup.string().nullable().default(""), //.required("expiry date is required"),
      documentImage: Yup.string().nullable().default(""),
      documentImageBack: Yup.string().nullable().default(""),
      remarks: Yup.string(),
    })
  ),

  // cpfAccountDetails: Yup.array().when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) =>
  //     schema.of(
  //       Yup.object().shape({
  //         // nric: Yup.string().required("NRIC is required"),
  //         employeeCPFAccountNumber: Yup.string()
  //           .typeError("Employee CPF Account Number")
  //           .required("Employee CPF Account Number is required"),
  //         additionalCPFAccount: Yup.string()
  //           .typeError("Additional CPF Account")
  //           .required("Additional CPF Account is required"),
  //         employerCPFAccount: Yup.string()
  //           .typeError("Employer CPF Account")
  //           .required("Employer CPF Account is required"),
  //         cpfStatus: Yup.string().required("CPF Status is required"),
  //         autoDetectCPF: Yup.bool().required("Auto Detect CPF is required"),
  //         includeIR8ASubmission: Yup.bool().required(
  //           "Include IR8A Submission is required"
  //         ),
  //         sdfRequired: Yup.bool().required("SDF Required is required"),
  //         voluntaryCPFContribution: Yup.number()
  //           .typeError("Voluntary CPF Contribution")
  //           .required("Voluntary CPF Contribution is required"),
  //         employeeAmount: Yup.number()
  //           .typeError("Employee Amount")
  //           .required("Employee Amount is required"),
  //         employerAmount: Yup.number()
  //           .typeError("Employer Amount")
  //           .required("Employer Amount is required"),
  //         isActive: Yup.bool().required("Statis is required"),
  //       })
  //     ),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});

// export const importEmployyeValidationSchema = Yup.object().shape({
//   companyCode: Yup.number().required("companyCode is required"),
//   employeeCode: Yup.number().min(0).required("employeeCode is required"),
//   uniqueId: Yup.string().required("uniqueId is required"),
//   employeeType: Yup.string().required("Employee Type is required"),
//   icno: Yup.string().when("employeeType", {
//     is: (val) => val !== "3" && val !== 3,
//     then: (schema) => schema.required("Icno is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//   finNumber: Yup.string().when("employeeType", {
//     is: (val) => val === "3" && val === 3,
//     then: (schema) =>
//       schema
//         .required("Fin Number is required")
//         .matches(/^[A-Z]\d{7}[A-Z]$/, "Invalid Fin Number format"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   passCode: Yup.number().min(0).required("passCode is required"),
//   accountNo: Yup.string()
//     .matches(/^\d+$/, "accountNo should be numeric")
//     .required("accountNo is required"),
//   bankName: Yup.string().required("bankName is required"),

//   paymentMode: Yup.number()
//     .min(0, "paymentMode is required")
//     .required("paymentMode is required"),
//   remarks: Yup.string().default(""),
//   otDaySalary: Yup.number().min(0), //.required("otDaySalary is required"),
//   otHourlySalary: Yup.number().min(0), //.required("otHourlySalary is required"),
//   haveOverTimePay: Yup.boolean().required("haveOverTimePay is required"),
//   designationCode: Yup.number().min(0).required("designationCode is required"),
//   departmentCode: Yup.number().min(0).required("departmentCode is required"),
//   passExpiryDate: Yup.string().default(""),
//   passIssueDate: Yup.string().default(""),
//   prDate: Yup.string().default(""),
//   joinDate: Yup.string().default(""),
//   confirmationDate: Yup.string().default(""),
//   probationPeriodEnd: Yup.string().default(""),
//   probationPeriodStart: Yup.string().default(""),

//   // Salary Details
//   salaryType: Yup.string().required("Salary Type is required"),
//   // daySalary: Yup.number()
//   //   .transform((value, originalValue) =>
//   //     originalValue === "" ||
//   //     originalValue === null ||
//   //     originalValue === undefined
//   //       ? undefined
//   //       : Number(value)
//   //   )
//   //   .default("")
//   //   .when("salaryType", {
//   //     is: "Daily",
//   //     then: (schema) =>
//   //       schema
//   //         .required("Day Salary is required for Daily salary type")
//   //         .integer("Day Salary must be an integer")
//   //         .min(1, "Day Salary must be greater than 0"),
//   //     otherwise: (schema) => schema.notRequired(),
//   //   }),
//   // hourlySalary: Yup.number()
//   //   .typeError("Hourly Salary must be a valid number")
//   //   .transform((value, originalValue) =>
//   //     originalValue === "" ||
//   //     originalValue === null ||
//   //     originalValue === undefined
//   //       ? undefined
//   //       : isNaN(originalValue)
//   //       ? NaN
//   //       : Number(originalValue)
//   //   )
//   //   .default("")
//   //   .when("salaryType", {
//   //     is: "Hourly",
//   //     then: (schema) =>
//   //       schema
//   //         .required("Hourly Salary is required for Hourly salary type")
//   //         .min(0.01, "Hourly Salary must be greater than 0"),
//   //     otherwise: (schema) => schema.notRequired(),
//   //   }),

//   // basicSalary: Yup.number()
//   //   .transform((value, originalValue) =>
//   //     originalValue === "" ||
//   //     originalValue === null ||
//   //     originalValue === undefined
//   //       ? undefined
//   //       : Number(value)
//   //   )
//   //   .default("")
//   //   .when("salaryType", {
//   //     is: "Monthly",
//   //     then: (schema) =>
//   //       schema
//   //         .required("Basic Salary is required for Monthly salary type")
//   //         .integer("Basic Salary must be an integer")
//   //         .min(1, "Basic Salary must be  greater than 1"),
//   //     otherwise: (schema) => schema.notRequired(),
//   //   }),

//   sdlBreakdown: Yup.string().default(""),
//   cpfEntitled: Yup.string().default(""),
//   // haveCPF: Yup.boolean().required("haveCPF is required"),
//   residentialType: Yup.string().when("employeeType", {
//     is: (val) => val !== "3" && val !== 3,
//     then: (schema) => schema.required("CPF contribution type is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//   contributionCode: Yup.string().when("employeeType", {
//     is: (val) => val !== "3" && val !== 3,
//     then: (schema) =>
//       schema
//         .typeError("Contribution Code is required")
//         .required("Contribution Code is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   prcpfType: Yup.string().when("employeeType", {
//     is: (val) => val !== "3" && val !== 3,
//     then: (schema) => schema.required("PR CPF Type is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   contributesSDL: Yup.string().when("employeeType", {
//     is: (val) => val !== "3" && val !== 3,
//     then: (schema) =>
//       schema
//         .typeError("Contribute SDL is required")
//         .required("Contribute SDL is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   identification: Yup.string().default(""), // .required("identification is required"),
//   postalCode: Yup.string()
//     .matches(/^\d{6}$/, "postalCode should be 6 digits")
//     .required("postalCode is required"),
//   country: Yup.string().required("country is required"),
//   address3: Yup.string().default(""),
//   address2: Yup.string().default(""),
//   address1: Yup.string().required("address1 is required"),
//   isActive: Yup.bool().required("isActive is required"),
//   relationship: Yup.string().default(""), // .required("relationship is required"),
//   emergencyContactPerson: Yup.string().default(""),
//   // .required(
//   //   "emergencyContactPerson is required"
//   // ),
//   academicQualification: Yup.string().default(""),
//   // .required(
//   //   "academicQualification is required"
//   // ),
//   personalEmail: Yup.string().default(""), //.email().required("personalEmail is required"),
//   email: Yup.string().required("email is required"),
//   bloodGroup: Yup.string().default(""),
//   // .oneOf(["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"])
//   // .required("bloodGroup is required"),
//   race: Yup.string().default(""), //.required("race is required"),
//   religion: Yup.string().default(""), //.required("religion is required"),
//   nationality: Yup.string().default(""), //.required("nationality is required"),
//   placeOfBirth: Yup.string().default(""), //.required("placeOfBirth is required"),
//   dob: Yup.string().required("dob is required"),
//   maritalStatus: Yup.string()
//     .oneOf(["Single", "Married", "Divorced", "Widowed"])
//     .required("maritalStatus is required"),
//   gender: Yup.string().required("gender is required"),
//   fullName: Yup.string().required("fullName is required"),
//   // otPaidInDays: Yup.number().min(0).required("otPaidInDays is required"),

//   officeNo: Yup.string().default(""),
//   createUser: Yup.string().required("createUser is required"),
//   createDate: Yup.string().required("createDate is required"),
//   modifyUser: Yup.string().required("modifyUser is required"),
//   modifyDate: Yup.string().required("modifyDate is required"),
//   // locationCode: Yup.string().required('locationCode is required'),
//   // mode: Yup.string().required("mode is required"),
//   // dateFormat: Yup.string().required("dateFormat is required"),
//   employeePhoto: Yup.string().default(""),
//   skilledOrUnSkilled: Yup.string().default(""),
//     // .oneOf(["S", "U"])
//     // .required("skilledOrUnSkilled is required"),
//   employmentStatus: Yup.string().default(""),
//     // .min(0)
//     // .required("employmentStatus is required"),
//   resignedDate: Yup.string().default(""),
//   jobTitle: Yup.string().default(""),
//   workDayPerWeek: Yup.number()
//     .min(0)
//     .max(7)
//     .required("workDayPerWeek is required"),
//   reportTo: Yup.string().default(""),
//   haveLoginPermission: Yup.boolean().required(
//     "haveLoginPermission is required"
//   ),
//   // dailyAllowance: Yup.number().min(0).required("dailyAllowance is required"),
//   haveOverTimePayForExtraHours: Yup.boolean().required(
//     "haveOverTimePayForExtraHours is required"
//   ),
//   haveNeedAttendance: Yup.boolean().required("haveNeedAttendance is required"),
//   restDay: Yup.string().default(""), // .required("restDay is required"),
//   loginUserName: Yup.string().default(""),
//   aliasName: Yup.string().default(""), // .required("aliasName is required"),
//   preferedName: Yup.string().default(""),
//   groups: Yup.string().default(""),
//   surpervisorName: Yup.string().default(""),
//   payrollFrequency: Yup.string().default(""),
//   skillSet: Yup.string().default(""),
//   workingHoursPerDay: Yup.number()
//     .min(0)
//     .max(24)
//     .required("workingHoursPerDay is required"),
//   // noofworkingDaysPerWeek: Yup.number()
//   //   .min(1)
//   //   .max(7)
//   //   .required("noofworkingDaysPerWeek is required"),
//   // basicPayAmountType: Yup.string()
//   //   .oneOf(["SGD", "USD", "EUR"])
//   //   .required("basicPayAmountType is required"),
//   // superAdmin: Yup.boolean().required("superAdmin is required"),
//   workingTimingPerDay: Yup.string()
//     // .min(0)
//     // .max(24)
//     .required("workingTimingPerDay is required"),
//   userSecurity: Yup.string().default(""),
//   claimsTypes: Yup.string().default(""),
//   lengthofNoticePeriod: Yup.string().required(
//     "lengthofNoticePeriod is required"
//   ),
//   fundDonation: Yup.string().default(""),
//   // clockInAndOutOnMobile: Yup.string().required(
//   //   "Clock In And Out On Mobile is required"
//   // ),
//   jobGrade: Yup.string().default(""),
//   hpno: Yup.string()
//     .matches(/^\d+$/, "mobileNo should be numeric")
//     .required("mobileNo is required"),

//   mondayWorkingMode: Yup.string().required("Monday Working Mode is required"),
//   tuesdayWorkingMode: Yup.string().required("Tuesday Working Mode is required"),
//   wednesdayWorkingMode: Yup.string().required(
//     "Wednesday Working Mode is required"
//   ),
//   thursdayWorkingMode: Yup.string().required(
//     "Thursday Working Mode is required"
//   ),
//   fridayWorkingMode: Yup.string().required("Friday Working Mode is required"),
//   saturdayWorkingMode: Yup.string().required(
//     "Saturday Working Mode is required"
//   ),
//   sundayWorkingMode: Yup.string().required("Sunday Working Mode is required"),
//   localContactNumber: Yup.number()
//     .typeError("Enter Local Contact Number")
//     .required("Enter Local Contact Number"),
//   overseasContactNumber: Yup.number()
//     .typeError("Enter Overseas Contact Number")
//     .required("Enter Overseas Contact Number"),

//   workExperienceDetails: Yup.array().of(
//     Yup.object().shape({
//       companyCode: Yup.number(),
//       code: Yup.number(),
//       employeeCode: Yup.number(),
//       department: Yup.string().required("Please enter department"),
//       designation: Yup.string().required("Please enter designation"),
//       weFromdate: Yup.string().required("Please select start date"),
//       weTodate: Yup.string().required("Please select end date"),
//       salary: Yup.number().required("Please enter salary"),
//       remarks: Yup.string().default(""),
//       createUser: Yup.string().default(""),
//       createDate: Yup.string().default(""),
//       modifyUser: Yup.string().default(""),
//       modifyDate: Yup.string().default(""),
//       isActive: Yup.boolean(),
//     })
//   ),

//   inventoryDetails: Yup.array().of(
//     Yup.object().shape({
//       companyCode: Yup.number(),
//       code: Yup.number(),
//       employeeCode: Yup.number(),
//       itemName: Yup.string().required("Please enter item name"),
//       quantity: Yup.number().min(1).required("Please enter item quantity"),
//       dateOfIssue: Yup.string().required("Please select issue date"),
//       dateOfCollection: Yup.string().required("Please select collect date"),
//       description: Yup.string().default(""),
//       createUser: Yup.string().default(""),
//       createDate: Yup.string().default(""),
//       modifyUser: Yup.string().default(""),
//       modifyDate: Yup.string().default(""),
//       isActive: Yup.boolean(),
//     })
//   ),
//   employeesLeaveDetails: Yup.array().of(
//     Yup.object().shape({
//       slNo: Yup.number(),
//       companyCode: Yup.number(),
//       employeeCode: Yup.number(),
//       leaveCode: Yup.number().min(1).typeError().required("Select leave type"),
//       leaveYear: Yup.number().required(),
//       noOfAllotedDays: Yup.number(),
//       noOfLeaveCarryForwardFromLastYear: Yup.number(),
//       leaveTaken: Yup.number(),
//       leaveCarryForwardtoNextYear: Yup.number(),
//       amountPaidForLeaveDays: Yup.number(),
//       balanceLeaveDays: Yup.number(),
//       totalLeaveDays: Yup.number(),
//       createDate: Yup.date(),
//       modifyDate: Yup.date(),
//       user: Yup.string().default(""),
//     })
//   ),

//   // // Nested validation for allowance details
//   allowanceDetails: Yup.array().of(
//     Yup.object().shape({
//       companyCode: Yup.number(),
//       code: Yup.number().required(),
//       employeeCode: Yup.string().default(""),
//       departmentCode: Yup.number(),
//       description: Yup.string().required(),
//       haveCPF: Yup.boolean(),
//       isTaxPayable: Yup.boolean(),
//       createUser: Yup.string().default(""),
//       createDate: Yup.string().default(""),
//       modifyUser: Yup.string().default(""),
//       modifyDate: Yup.string().default(""),
//       isActive: Yup.boolean(),
//       amount: Yup.number()
//         .typeError("Amount must be number")
//         .required("Amount is required"),
//       effectiveDateFrom: Yup.string().required("Select Effective From Date"),
//       effectiveDateTo: Yup.string().required("Select Effective To Date"),
//     })
//   ),

//   // // Nested validation for deduction details
//   deductionDetails: Yup.array().of(
//     Yup.object().shape({
//       companyCode: Yup.number(),
//       code: Yup.number().required(),
//       employeeCode: Yup.string().default(""),
//       departmentCode: Yup.number(),
//       description: Yup.string().required(),
//       haveCPF: Yup.boolean(),
//       isTaxPayable: Yup.boolean(),
//       createUser: Yup.string().default(""),
//       createDate: Yup.string().default(""),
//       modifyUser: Yup.string().default(""),
//       modifyDate: Yup.string().default(""),
//       isActive: Yup.boolean(),
//       amount: Yup.number()
//         .typeError("Amount must be number")
//         .required("Amount is required"),
//       effectiveDateFrom: Yup.string().required("Select Effective From Date"),
//       effectiveDateTo: Yup.string().required("Select Effective To Date"),
//     })
//   ),
// });
